var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 5.33398L8.66683 5.33398",
    stroke: "#242428",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7.33366C1.3335 5.13377 1.3335 4.03383 2.01691 3.35041C2.70033 2.66699 3.80028 2.66699 6.00016 2.66699H6.66683C8.86672 2.66699 9.96666 2.66699 10.6501 3.35041C11.3335 4.03383 11.3335 5.13377 11.3335 7.33366V8.66699C11.3335 10.8669 11.3335 11.9668 10.6501 12.6502C9.96666 13.3337 8.86672 13.3337 6.66683 13.3337H6.00016C3.80028 13.3337 2.70033 13.3337 2.01691 12.6502C1.3335 11.9668 1.3335 10.8669 1.3335 8.66699L1.3335 7.33366Z",
    stroke: "#242428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 5.93789L11.4174 5.86863C12.828 4.7048 13.5332 4.12289 14.1 4.40387C14.6668 4.68484 14.6668 5.61635 14.6668 7.47937V8.52193C14.6668 10.385 14.6668 11.3165 14.1 11.5974C13.5332 11.8784 12.828 11.2965 11.4174 10.1327L11.3335 10.0634",
    stroke: "#242428",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.72378bc8ab273b582047cc6026a02251.svg";
export { ForwardRef as ReactComponent };